import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarHiddenRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSidebarHiddenRightWide"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 4C3.11929 4 2 5.11929 2 6.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V6.5C22 5.11929 20.8807 4 19.5 4H4.5ZM18.5 7C18.7761 7 19 7.22386 19 7.5V16.5C19 16.7761 18.7761 17 18.5 17C18.2239 17 18 16.7761 18 16.5V7.5C18 7.22386 18.2239 7 18.5 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarHiddenRightWide;
